var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[(!_vm.isPrintable)?_c('div',{staticClass:"text-center d-print-none"},[_c('h2',{staticClass:"d-print-none"},[_vm._v("Preparing to print "),_c('i',{staticClass:"fas fa-spinner fa-spin"})])]):_vm._e(),_c('print',{attrs:{"mobile-shipment-id":this.$route.params.shipmentId},on:{"isPrintReady":_vm.print}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }